import { render, staticRenderFns } from "./NTOHome.vue?vue&type=template&id=19bf8076&scoped=true&"
import script from "./NTOHome.vue?vue&type=script&lang=js&"
export * from "./NTOHome.vue?vue&type=script&lang=js&"
import style0 from "./NTOHome.vue?vue&type=style&index=0&id=19bf8076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf8076",
  null
  
)

export default component.exports